import type { AppConfig } from '@ms-cloudpack/common-types';
import path from 'path';

const configDirTemplate = '{configDir}';

/**
 * Expand template variables in module resolution paths.
 * Currently supports `{configDir}` to reference the configuration file's directory.
 */
export function expandModulePaths(params: { appConfig: AppConfig; configPath: string }): void {
  const {
    appConfig: { resolve },
    configPath,
  } = params;

  if (!path.isAbsolute(configPath)) {
    throw new Error(`configPath must be an absolute path, got: "${configPath}"`);
  }

  if (!resolve?.modules) {
    return;
  }

  const configDir = path.dirname(configPath);

  // Process each module path and expand template variables
  resolve.modules = resolve.modules.map((origModulePath) => {
    let modulePath = origModulePath;
    if (modulePath.startsWith(configDirTemplate)) {
      // Replace template at start of path with actual directory
      modulePath = modulePath.replace(configDirTemplate, configDir);
    }

    if (modulePath.includes(configDirTemplate)) {
      // There were multiple occurrences, or it was not at the start
      throw new Error(
        `${configDirTemplate} template variable is only allowed at the beginning of a \`resolve.modules\` path. Received: "${modulePath}"`,
      );
    }

    return modulePath;
  });
}
